module.exports = function(app) {
    app.run(['Service', function (Service) {
        return new Service({

       name: 'saveSpendingAccountInformation',
       group: 'eprsvc',
       url: '/eprsvc/x-services/secure/spending-accounts/v1/:umi/:groupNumber',
       cache: false,

       save: function(payload){
           return this.post(payload);
       }

       });
    }]);
};
